import React from 'react';
import { Link } from 'react-router-dom';
import { LOGO_URL, PRODUCT_NAME, STORE_URL } from '../constants/site';
export function Footer() {
  return <footer className="w-full border-t border-slate-200 bg-slate-50" data-id="element-50" data-mp="3ggka709t7m26">
      <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6" data-id="element-51" data-mp="32p5nojgp12qd">
        <div className="flex flex-col gap-8 sm:flex-row sm:items-start sm:justify-between" data-id="element-52" data-mp="36p6d0z5byyc7">
          <div className="max-w-sm" data-id="element-53" data-mp="3uf0n58y9m8sr">
            <div className="flex items-center gap-2" data-id="element-54" data-mp="3ug3fllb8kjas">
              <span className="flex h-8 w-8 items-center justify-center overflow-hidden rounded-lg border border-slate-200 bg-white" data-id="element-55" data-mp="38qvaxf23pqn">
                <img src={LOGO_URL} alt="" className="h-6 w-6 object-contain" data-id="element-56" data-mp="3lf5bl30ssbs7" />
              </span>
              <span className="text-base font-bold text-slate-900" data-id="element-57" data-mp="3qcnhekjiqavz">
                {PRODUCT_NAME}
              </span>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-slate-500" data-id="element-58" data-mp="29xvqkc20tbos">
              Capture selected X posts and replies as one clean PNG. Local-only,
              privacy-first.
            </p>
          </div>

          <div className="flex flex-wrap gap-x-12 gap-y-6" data-id="element-59" data-mp="3lbdd6ucasbmc">
            <div data-id="element-60" data-mp="3gbqz6ionarch">
              <h3 className="text-xs font-semibold uppercase tracking-wide text-slate-400" data-id="element-61" data-mp="3gca5t38uhtb7">
                Product
              </h3>
              <ul className="mt-3 space-y-2 text-sm" data-id="element-62" data-mp="3q8wr1t532mdr">
                <li data-id="element-63" data-mp="3q726wh1myyaq">
                  <a href="/#features" className="text-slate-600 hover:text-slate-900" data-id="element-64" data-mp="3qapwx67vh2kp">
                    Features
                  </a>
                </li>
                <li data-id="element-65" data-mp="hstrybs1e611">
                  <a href="/#how" className="text-slate-600 hover:text-slate-900" data-id="element-66" data-mp="ht3ajear5awp">
                    How it works
                  </a>
                </li>
                <li data-id="element-67" data-mp="quji7ea6myx8">
                  <a href="/#faq" className="text-slate-600 hover:text-slate-900" data-id="element-68" data-mp="qtrpqcbvthb6">
                    FAQ
                  </a>
                </li>
                <li data-id="element-69" data-mp="tt088o5w6ipf">
                  <a href={STORE_URL} target="_blank" rel="noopener noreferrer" className="text-slate-600 hover:text-slate-900" data-id="element-70" data-mp="yu7hkrnonpy7">
                    Chrome Web Store
                  </a>
                </li>
              </ul>
            </div>
            <div data-id="element-71" data-mp="1ckkqaw8ef8ol">
              <h3 className="text-xs font-semibold uppercase tracking-wide text-slate-400" data-id="element-72" data-mp="1cl2qu523g92b">
                Legal
              </h3>
              <ul className="mt-3 space-y-2 text-sm" data-id="element-73" data-mp="1mjsd0a10wfod">
                <li data-id="element-74" data-mp="1ml3eu4awrdcu">
                  <Link to="/privacy" className="text-slate-600 hover:text-slate-900" data-id="element-75" data-mp="1mhpcgw28v45e">
                    Privacy Policy
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-10 border-t border-slate-200 pt-6" data-id="element-76" data-mp="3tai21c2h9gjb">
          <p className="text-xs leading-relaxed text-slate-400" data-id="element-77" data-mp="2afdgt88id0mo">
            {PRODUCT_NAME} is an independent project and is not affiliated with,
            endorsed by, or sponsored by X Corp. “X”, “Twitter”, the X logo and
            the Twitter bird are trademarks of X Corp. ©{' '}
            {new Date().getFullYear()} {PRODUCT_NAME}.
          </p>
        </div>
      </div>
    </footer>;
}